import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/WhyTopTier.css';
import logo from '../assets/logo.png';

const WhyTopTier = () => {
    const navigate = useNavigate();

    return (
        <div className="why-us-container">
            <nav className="why-us-nav">
                <div className="nav-logo" onClick={() => navigate('/')}>
                    <img src={logo} alt="Top Tier Processing" />
                </div>
                <div className="nav-links">
                    <button className="nav-link-btn" onClick={() => navigate('/careers')}>Careers</button>
                    <button className="nav-login-btn" onClick={() => navigate('/app')}>
                        Client Login
                    </button>
                </div>
            </nav>

            <header className="why-us-hero">
                <div className="hero-content">
                    <h1>Operations Reimagined</h1>
                    <p className="hero-subtitle">
                        Experience the difference of a partner who combines decades of expertise with a relentless commitment to communication.
                    </p>
                </div>
            </header>

            <section className="why-us-section daily-comm-section">
                <div className="comm-content">
                    <h2>The Daily Update Guarantee</h2>
                    <p className="comm-intro">
                        Ghosting is not in our vocabulary. We believe silence is the enemy of a smooth closing.
                    </p>
                    <div className="comm-card">
                        <h3>We Touch Your File Every Single Day</h3>
                        <p>
                            You will never have to guess where your loan stands. Our team reviews every active file daily.
                        </p>
                        <ul className="comm-list">
                            <li>
                                <strong>Status Updates:</strong> A clear note updating you on exactly what happened today.
                            </li>
                            <li>
                                <strong>Action Plans:</strong> If we are waiting on something, we tell you <em>what</em> we need, <em>when</em> we expect it, and <em>when</em> we will follow up next.
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="why-us-section stats-section">
                <div className="stats-grid">
                    <div className="stat-card">
                        <h3>10+ Years</h3>
                        <p>Average Experience Per Team Member</p>
                    </div>
                    <div className="stat-card">
                        <h3>Tech-Forward</h3>
                        <p>Modern Systems for Speed & Transparency</p>
                    </div>
                    <div className="stat-card">
                        <h3>Reliable</h3>
                        <p>We Hit Our Dates. Period.</p>
                    </div>
                </div>
            </section>

            <section className="why-us-section cta-section">
                <h2>Ready to Elevate Your Business?</h2>
                <p>Stop managing your processing and start managing your growth. Partner with Top Tier today.</p>
                <a href="mailto:info@toptiermp.com" className="partner-btn">
                    Partner With Us
                </a>
            </section>

            <footer className="homepage-footer">
                <div className="footer-content">
                    <p>
                        <span className="footer-link" onClick={() => navigate('/careers')}>Careers</span> |
                        Contact Us: <a href="mailto:info@toptiermp.com">info@toptiermp.com</a>
                    </p>
                    <p className="footer-nmls">NMLS #2256200 | Currently licensed in FL</p>
                    <p>&copy; {new Date().getFullYear()} Top Tier Mortgage Processing. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default WhyTopTier;
